<template lang="pug">
	
	.amerikkkan
		amerikkkan-intro.amerikkkan-section
		poster-overlay(ref="posters")
		.next-image(ref='nextImage')
			img(src="assets/images/land-of-free.jpg")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'

	import AmerikkkanIntro from './_components/amerikkkan-intro.vue'
	import Background from '../../components/background.vue'
	import Scrollable from '../../abstracts/scrollable'
	import PosterOverlay from './_components/poster-overlay.vue'
	import Globals from '~utils/Globals.js'

  	@Component({
		name: 'Political',
		components: { Background,AmerikkkanIntro,PosterOverlay }
	})

	class Political extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$posterOverlay = this.$refs.posters.$el
			this.$posters = this.$refs.posters.$posters
			this.$nextImage = this.$refs.nextImage
			this.$introContent = this.$el.querySelector('.amerikkkan-section .amerikkkan-intro-content')
			this.$introContent1 = this.$el.querySelector('.amerikkkan-section .amerikkkan-intro-content .splited-text')
			this.$spotify = this.$el.querySelector('.amerikkkan-section .amerikkkan-intro-content .spotify-module')
		}

		initTimeline () {
			super.initTimeline()

			const h = Globals.height
			
		
			const start_in = Math.floor(this.$introContent.getBoundingClientRect().top - this.bounds.top - this.scroller.scroll.position) - window.innerHeight*.5 + this.$introContent.getBoundingClientRect().height * .5
			
			const start_in_ratio = start_in / (this.newHeight)

			const h_ratio = window.innerHeight / (this.newHeight)


			this.tl.set(this.$introContent,{opacity:1},0)
			this.tl.set(this.$nextImage,{opacity:0},0)
			this.tl.set(this.$nextImage.querySelector('img'),{opacity:1}, 0)

			this.tl.fromTo([this.$posterOverlay,this.$nextImage],1,{y:0},{y:this.newHeight, ease: Power0.easeNone},0)
						
			this.tl.fromTo(this.$introContent1,
				(1-start_in_ratio - h_ratio),
				{y:0},
				{y:(this.newHeight - h - start_in), 
				ease: Power0.easeNone},
				start_in_ratio
			)
			
			this.tl.fromTo(this.$spotify,
				(1-start_in_ratio - h_ratio),
				{y:0},
				{y:300, 
				ease: Power0.easeNone},
				start_in_ratio
			)
			
			this.tl.set(this.$introContent,{opacity:0},(1 - h_ratio))
			this.tl.set(this.$nextImage,{opacity:1},(1 - h_ratio))
			this.tl.fromTo(this.$nextImage,h_ratio*.9,{scale:1.2},{scale:1},(1 - h_ratio))
			this.tl.set(this.$nextImage.querySelector('img'),{opacity:0}, 1)
			
			const start = start_in_ratio
			const end = 1- h_ratio


			for(let i = 0; i < this.$posters.length; i++) {
				
				const rand_start = Math.random()*(end-.05 - start) + start/2
				const rotZ = this.$refs.posters.posters[i].rotation

				const rand_start2 = Math.random()*(1.2 - .8) + .8

				this.tl.to(this.$posters[i],(1-rand_start - h_ratio),{y:0,x:0,rotationZ:rotZ, ease: Power0.easeNone},rand_start)

				this.tl.to(this.$posters[i],h_ratio,{y:-(h * 2)*rand_start2, ease: Power0.easeNone},(1 - h_ratio))
			}

		}

		raf (y) {
			super.raf(y)
					}


		_resize () {
			super._resize()

			this.offset = Globals.responsiveHeight(300)

			this.newHeight = this.offset + this.bounds.height
			this.bounds.height = this.newHeight
			this.$el.style.height = this.bounds.height + "px"

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.newHeight
			}

			this.$refs.posters._resize()

			this.initTimeline ()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default Political

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.amerikkkan
		width 100%
		background #0f0d37
		position relative
		z-index 40

		.amerikkkan-section
			position relative
			z-index 30

		.posters-overlay
			position absolute
			top 0
			left 0
			z-index 50
			will-change transform
			// opacity .3
			// background red

		.next-image
			position absolute
			top 0
			left 0
			z-index 40
			will-change transform
			height 100vh
			width 100%
			opacity 0
			pointer-events none

			img
				height 100%
				width 100%
				object-fit cover

</style>


// WEBPACK FOOTER //
// amerikkkan.vue?2d6fc4fc